import { render, staticRenderFns } from "./AddOrUpdatePrescriptionsModal.vue?vue&type=template&id=f64b289c&"
import script from "./AddOrUpdatePrescriptionsModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdatePrescriptionsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdatePrescriptionsModal.vue?vue&type=style&index=0&id=f64b289c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports